import * as Yup from 'yup';

import { requireEmailValidation } from 'helpers/validate';

export const formAdminSchema = Yup.object().shape({
  email: requireEmailValidation,
  phone: Yup.string(),
  password: Yup.string().min(6),
  gender: Yup.string(),
  lastName: Yup.string(),
  firstName: Yup.string().min(1).required(),
});

export const formUpdateAdminSchema = Yup.object().shape({
  email: requireEmailValidation,
  phone: Yup.string(),
  password: Yup.string().min(6),
  gender: Yup.string(),
  lastName: Yup.string(),
  firstName: Yup.string().min(1).required(),
});
